import React from 'react';
import { arrayOf, bool, string } from 'prop-types';

import { Style } from 'nordic/style';

import { SECTIONS_BY_VIEW } from '../../../utils/constants';

const getSectionStylesFile = (type, theme, device) => {
  if (!theme) {
    return `${type}-${device}.css`;
  }

  return `${type}-${theme}-${device}.css`;
};

const SectionStyles = ({ types, theme, isMobile, isThemed }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {types?.map((type) => (
      <Style
        key={type}
        href={getSectionStylesFile(
          type,
          isThemed || SECTIONS_BY_VIEW.calm.includes(type) ? theme : null,
          isMobile ? 'mobile' : 'desktop',
        )}
        critical
      />
    ))}
  </>
);

SectionStyles.propTypes = {
  types: arrayOf(string),
  theme: string,
  isMobile: bool,
  isThemed: bool,
};

export default SectionStyles;
